__turbopack_context__.v({
  "backLink": "pbuGHq_backLink",
  "card": "pbuGHq_card",
  "container": "pbuGHq_container",
  "ctaLink": "pbuGHq_ctaLink",
  "errorMessage": "pbuGHq_errorMessage",
  "form": "pbuGHq_form",
  "hint": "pbuGHq_hint",
  "input": "pbuGHq_input",
  "inputGroup": "pbuGHq_inputGroup",
  "label": "pbuGHq_label",
  "logoLink": "pbuGHq_logoLink",
  "newHereCard": "pbuGHq_newHereCard",
  "newHereDescription": "pbuGHq_newHereDescription",
  "newHereTitle": "pbuGHq_newHereTitle",
  "notFoundIcon": "pbuGHq_notFoundIcon",
  "notFoundMessage": "pbuGHq_notFoundMessage",
  "notFoundText": "pbuGHq_notFoundText",
  "notFoundTitle": "pbuGHq_notFoundTitle",
  "page": "pbuGHq_page",
  "submitButton": "pbuGHq_submitButton",
  "subtitle": "pbuGHq_subtitle",
  "successIcon": "pbuGHq_successIcon",
  "successMessage": "pbuGHq_successMessage",
  "successText": "pbuGHq_successText",
  "successTitle": "pbuGHq_successTitle",
  "title": "pbuGHq_title",
});
